<div class="text-center">
    <img
        src="./assets/images/success.svg"
        alt="Publish Campaign"
        title="Publish Campaign"
        class="mb-3"
    />
    <div class="text-center">
        <h4 class="montserrat-bold text-uppercase text-gray-500 mb-4">congratulations !</h4>
        You will receive an email confirmation once it gets approved.<br /><br />
        If your campaign is subject to municipality fees charges, these charges will be added to
        your invoice.
    </div>
</div>
<div class="d-flex align-items-center justify-content-center">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close>Done</button>
</div>
